import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Medication, PrescriptionInstruction } from "src/api/types";
import { WEEKS } from "src/constants/weeks";

interface Props1 {
  index: number;
  isInjectable: boolean;
  instruction: PrescriptionInstruction;
  medication: Medication | null;
}

const MedicationInstruction = ({
  index,
  isInjectable,
  instruction,
}: // medication,
Props1) => {
  return (
    <Stack gap={1} ml={1}>
      {isInjectable ? (
        <Stack gap={1} direction="row" alignItems="center">
          <Typography sx={{ textDecoration: "underline" }}>
            {WEEKS[index]}
          </Typography>
          <Typography>[{instruction.dosage}]</Typography>
        </Stack>
      ) : null}
      <Typography>{instruction.value}</Typography>
    </Stack>
  );
};

export default MedicationInstruction;
